/**
 *  © 2024-2025 DXC Technology, all rights reserved.
 *  Material published by DXC Technology on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React from 'react';
import { withTranslation } from 'react-i18next';
import ImgCrop from '../Common/ImgCrop';
import LazyLoad from 'react-lazyload';
const RewardsMyUnited = ({ t, rewardCard }) => {
  return (
    <div className="rewardCard ">
      <div className="grid-6 ratio">
        <div className="mu-content">
          <div className="mu-item article-card article">
            <a
              href={rewardCard?.CTAUrl?.value?.url ? rewardCard.CTAUrl.value.url : '#'}
              tabIndex="-1"
              aria-hidden="true"
              target={rewardCard?.CTAUrl?.value?.target}
            >
              <div className="img-holder">
                {rewardCard?.Image && (
                  <LazyLoad once={true} offset={100}>
                    <ImgCrop
                      imgCrop={rewardCard.Image.value.Crops}
                      alt={rewardCard.Image.value.AltText}
                      isWebpAvailable={rewardCard.Image.value.isWebpAvailable}
                    ></ImgCrop>
                  </LazyLoad>
                )}
              </div>
            </a>
            <div className="mu-item__info">
              {rewardCard?.CTATitle?.value && (
                <a
                  className="titleCard"
                  href={rewardCard?.CTAUrl?.value?.url}
                  target={rewardCard?.CTAUrl?.value?.target}
                >
                  {rewardCard?.CTATitle?.value}
                </a>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(React.memo(RewardsMyUnited));
